export enum SectionBannerVariants {
  EditProfile = 'EDIT_PROFILE',
  SurveyActive = 'SURVEY_ACTIVE',
  SurveyAnswered = 'SURVEY_ANSWERED',
  SurveyExpired = 'SURVEY_EXPIRED',
  SurveyAlreadyFilled = 'SURVEY_ALREADY_FILLED',
  SurveyLoading = 'SURVEY_LOADING',
  SomethingWentWrong = 'SOMETHING_WENT_WRONG',
}
